import React from 'react';
import { useMessengerContext } from '../../hooks/useMessengerContext';
import "./ChatBoxHeader.css";

const ChatBoxHeader = ({ onBackToChatMenuForCSS, onToChatProfileForCSS }) => {

    const { state } = useMessengerContext();
    const { otherUserDisplay, community, currentConversation } = state;

    const isBotConversation = currentConversation?.members?.includes(currentConversation.communityId);
    const displayTitle = isBotConversation
      ? `${community?.title} AI`
      : otherUserDisplay?.name;
    const displayImage = isBotConversation
      ? community?.pics?.[0]
      : otherUserDisplay?.pics?.[0];

    return (
      <div className="headerContainer">
        <div className="chatbox-header-back-btn" onClick={onBackToChatMenuForCSS}>←|</div>
        <div className="chat-info-container">
          <img
            className="conversationImg"
            src={displayImage}
            alt=""
            onClick={onToChatProfileForCSS}
          />
          <div className="chat-title-block">
            <div id="chatTitle">Chat with {displayTitle}</div>
            {/* Not for bot conversations — "member of X" would just
                restate "Chat with X AI" right above it. */}
            {!isBotConversation && community?.title && (
              <div className="chat-title-subtitle">Member of {community.title}</div>
            )}
          </div>
        </div>
      </div>
    );
};

export default ChatBoxHeader;
